// 3rd-party modules
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// project modules
import AccountVpns from "../../components/accounts/vpns/AccountVpns";
import Loader from "../../components/shared/loader";
import { apiCall } from "../../helpers/apiHelper";
import { RootState } from "../../stores";

// apis
import * as AuthApi from "../../apis/authApi"

// models
import { Account } from "../../models/account";
import { AccountKiboshDevice } from "../../models/accountKiboshDevice";

export default function VpnPage() {
  const kiboshDevice = useSelector((state: RootState) => state.user.kiboshDevice) || new AccountKiboshDevice();

  const [currentAccount, setCurrentAccount] = useState<Account>(new Account());
  const [loading, setLoading] = useState<boolean>(false);

  let abortController = new AbortController();

  useEffect(() => {
    let abortController = new AbortController();

    getAccountAsync();

    return () => { abortController.abort(); }
  }, []);

  const getAccountAsync = async () => {
    const account = await getAccount(abortController.signal);

    if (account) {
      setCurrentAccount(account!);
    }
  }

  const getAccount = async (abortSignal?: AbortSignal) => {
    setLoading(true);
    const response = await apiCall(AuthApi.getAccount(abortSignal));
    setLoading(false);

    return response.success ? Account.toClass(response.data?.value) : null;
  };

  const onCancel = () => {
    abortController.abort();
  };

  return (
    <>
      {loading && <Loader/>}
      {
        !!currentAccount.accountId &&
        <AccountVpns account={currentAccount!} accountKiboshDevice={kiboshDevice} standalone={true} onCancel={onCancel} />
      }
    </>
  );
}
